import { RootState } from 'store';

export const selectDsmShading = (s: RootState) => s.dsmShading.data;
export const selectIsDirty = (s: RootState) => !s.dsmShading.data.inSync; // unsaved edits
export const selectIsRecomputing = (s: RootState) => s.dsmShading.data.isRecomputing;
export const selectShadingStatus = (s: RootState) => s.dsmShading.data.shadingStatus; // QUEUED vs RUNNING for the indicator
export const selectShadingError = (s: RootState) => s.dsmShading.data.shadingError;

// Which script the outstanding/in-flight run is: the full DSM bake or the shorter facet
// rebuild. Meaningful only while `selectIsRecomputing` is true — otherwise it's a leftover
// reading of the last run.
export const selectShadingRunType = (s: RootState) => s.dsmShading.data.runType;
export const selectIsRecomputingDsm = (s: RootState) =>
	s.dsmShading.data.isRecomputing && s.dsmShading.data.runType === 'dsm-edit';
export const selectIsRecomputingFacet = (s: RootState) =>
	s.dsmShading.data.isRecomputing && s.dsmShading.data.runType === 'facet-edit';
